<template>
  <v-select
    class="ads-select"
    v-bind="$attrs"
    v-on="$listeners"
    v-model="valueInternal"
    :placeholder="placeholder"
    outlined
    @change="handleChange"
    :ref="uid"
  />
</template>

<script>
const isIe = () => {
  const ua = window.navigator.userAgent;
  // MSIE 10 or below || MSIE11.x
  return (
    ua.indexOf("MSIE") !== -1 || !!navigator.userAgent.match(/Trident.*rv:11\./)
  );
};

export default {
  name: "AdsSelect",
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: " ",
    },
  },
  data() {
    return {
      uid: `ads-select_${this._uid}`,
      valueInternal: this.value,
    };
  },
  created() {
    if (isIe()) {
      // Hack to prevent IE clearing of v-select
      this.$watch("valueInternal", function (newVal, oldVal) {
        // Prevent clearing of value
        if (oldVal && !newVal && newVal !== undefined) {
          this.$refs[this.uid].setValue(oldVal);
        }
      });
    }
  },
  methods: {
    handleChange(val) {
      this.$emit("update:value", val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/variables.scss";

::v-deep.v-list {
  .v-list-item {
    transition: background-color 0.3s ease-out;
  }
  .v-list-item.v-list-item--highlighted {
    border-collapse: separate; /* for ie 9-11 */
    box-shadow: 0px 0px 0px 3px $ads-blue-3-dark inset;
    &:before {
      opacity: 0;
    }
  }
  &.theme--light {
    .v-list-item.v-list-item--active {
      background-color: $ads-navy;
      color: $ads-white !important;
    }
  }
  &.theme--dark {
    .v-list-item.v-list-item--active {
      background-color: $ads-navy-dark;
      color: $ads-01dp !important;
      &:before {
        opacity: 0;
      }
    }
  }
}
</style>
